import { render, staticRenderFns } from "./jxtchlist.vue?vue&type=template&id=73cc2048"
import script from "./jxtchlist.vue?vue&type=script&lang=js"
export * from "./jxtchlist.vue?vue&type=script&lang=js"
import style0 from "./jxtchlist.vue?vue&type=style&index=0&id=73cc2048&prod&lang=less"


/* normalize component */
import normalizer from "!E:\\SAAS-QSX\\qsx-web\\node_modules\\_vue-loader@15.11.1@vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports